/* global bodymovin */
document.addEventListener('DOMContentLoaded', () => {
    const fwcSection = document.querySelectorAll('.homepage-hero-section');

    fwcSection.forEach(section => {
        const fwpbgAnim = section.querySelector('.bg-animation-json');
        if (!fwpbgAnim) {
            return;
        }

        const dataJson = fwpbgAnim.getAttribute('data-json');
        let animationLoaded = false;

        function loadfwpbgAnim(elem, jsonPath) {
            if (animationLoaded) {
                return;
            }

            const animate = bodymovin.loadAnimation({
                container: elem,
                path: jsonPath,
                renderer: 'svg',
                loop: false,
                autoplay: false,
            });
            animate.setSpeed(1.5);
            animationLoaded = true;

            return animate;
        }

        const animate = loadfwpbgAnim(fwpbgAnim, dataJson);

        if (animate) {
            setTimeout(() => {
                animate.play();
            }, 300);
        }

        const observer = new MutationObserver(() => {
            if (!animationLoaded) {
                loadfwpbgAnim(fwpbgAnim, dataJson);
            }
        });

        observer.observe(section, {
            attributes: true,
            attributeFilter: ['class'],
        });
    });
});